<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="origens"
  (ngModelChange)="onChangeOrigensLancamentos()"
  (search)="onSearch()"
>
</sgt-multi-select>
